import { axiosClient } from "@/shared/api/axios-client";

/**
 * Una versión histórica del agregado SolicitudDePago.
 *
 * Espejo del DTO del backend `HistorialSolicitudItemDto`. SQL Server
 * mantiene esta info automáticamente vía Temporal Tables · cada UPDATE
 * genera una nueva entrada con [periodStart, periodEnd] indexado.
 */
export interface HistorialSolicitudItem {
  /** ISO timestamp UTC cuando esta versión comenzó a estar vigente. */
  periodStart: string;
  /** ISO timestamp UTC fin de validez ('9999-12-31...' si es la versión actual). */
  periodEnd: string;
  /** True si es la versión actualmente vigente en la tabla principal. */
  esActual: boolean;
  estado: string;
  tipo: string | null;
  subtipo: string | null;
  organizacionId: string | null;
  organizacionNombre: string | null;
  organizacionNumeroSociedad: string | null;
  areaNombre: string | null;
  proveedorNumero: number | null;
  proveedorRazonSocial: string | null;
  enviadaAContabilizacion: boolean;
  fechaUltimoEvento: string;
}

export async function obtenerHistorialSolicitud(
  solicitudId: string
): Promise<HistorialSolicitudItem[]> {
  const { data } = await axiosClient.get<HistorialSolicitudItem[]>(
    `/api/solicitudes/${solicitudId}/historial`
  );
  return data;
}
